import _ from 'lodash';
import React, { Component } from 'react';
import Scroll from 'react-scroll';

import dumbBem from 'dumb-bem';
import { makeStates } from 'dumb-bem/lib/plugins';
import tx from 'transform-props-with';
import config from 'config/landing';

import {
  FooterBlock,
  DemoForm,
} from 'components/landing/components';

import Header from './Header';
import Steps from './Steps';

const dumbMain = dumbBem('main', { plugins: [makeStates] });
const MainWrp = tx(dumbMain)('div');

export class Main extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hideComponent: !!this.getHash(),
    };

    this.demoForm = React.createRef();

    _.bindAll(this, [
      'scrollToDemoForm',
      'handleScrollToDemoForm',
      'getHash',
    ]);
  }

  componentDidMount() {
    this.handleScrollToDemoForm();
  }

  handleScrollToDemoForm() {
    const hash = this.getHash();
    if (hash !== 'demo-form') return false;

    setTimeout(() => {
      this.scrollToDemoForm();
      this.setState({ hideComponent: false });
    }, 500);
  }

  getHash() {
    const hash = _.get(this.props, 'location.hash');
    return hash ? hash.replace('#', '') : false;
  }

  scrollToDemoForm(animate = false) {
    const pos = this.demoForm.current.offsetTop - 70;
    if (animate) {
      Scroll.animateScroll.scrollTo(pos, { duration: 500 });
    } else {
      window.scrollTo(0, pos);
    }
  }

  render() {
    const { hideComponent } = this.state;

    return (
      <MainWrp hidden={hideComponent}>
        <Header scrollToDemoForm={this.scrollToDemoForm} />

        <Steps {...this.props} steps={config.steps} />

        <DemoForm
          title="Schedule a Demo"
          requestBtnTitle="REQUEST A DEMO"
          __ref={this.demoForm}
        />

        <FooterBlock />
      </MainWrp>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/components/landing/pages/main/Main.js